import React from "react";
import { columnHeaderGeneratorType, columnsVisibleType } from "../../../../common/types/search/search";

interface SearchResultsHeaderRowProps {
	columnsVisible: columnsVisibleType;
	columnHeaderGenerator: columnHeaderGeneratorType;
}

export function SearchResultsHeaderRow({
	columnsVisible,
	columnHeaderGenerator,
}: SearchResultsHeaderRowProps) {
	return (
		<thead>
			<tr>{columnHeaderGenerator(columnsVisible)}</tr>
		</thead>
	);
}
